// SHADOW MARKET™ — Kids Academy lessons (additive).
// 5 missions, each with multilingual slides + a mini-game id.
//
// Personajes: 'satoshi' | 'hodl' | 'miner' | 'oracle' | 'bear'
// Animaciones: 'monedas' | 'bitcoin-nace' | 'wallet' | '21m' | 'halving' | 'hodl-rocket' | null
// Minijuegos: 'atrapa-monedas' | 'quiz-satoshi' | 'hodl-challenge' | 'construye-bloque' | 'maquina-halving'

export const LECCIONES_KIDS = [
  {
    id: "que-es-el-dinero",
    nivel: 1,
    personaje: "satoshi",
    minijuego: "atrapa-monedas",
    titulo: {
      es: "¿Qué es el dinero?",
      en: "What is money?",
      sk: "Čo sú peniaze?",
    },
    slides: [
      {
        texto: {
          es: "¡Hola! Soy Satoshi y te voy a enseñar algo increíble. ¿Sabes para qué sirve el dinero?",
          en: "Hello! I'm Satoshi and I'll teach you something amazing. Do you know what money is for?",
          sk: "Ahoj! Som Satoshi a naučím ťa niečo úžasné. Vieš, na čo slúžia peniaze?",
        },
        animacion: null,
      },
      {
        texto: {
          es: "El dinero sirve para intercambiar cosas. Antes, la gente intercambiaba manzanas por gallinas. ¡Pero era muy difícil llevar una gallina a la tienda!",
          en: "Money is used to exchange things. Before, people traded apples for chickens. But it was very hard to carry a chicken to the store!",
          sk: "Peniaze slúžia na výmenu vecí. Predtým ľudia vymieňali jablká za sliepky. Ale bolo veľmi ťažké niesť sliepku do obchodu!",
        },
        animacion: "monedas",
      },
      {
        texto: {
          es: "Por eso inventaron las monedas y los billetes. Son mucho más fáciles de llevar. ¿Tienes alguna moneda en el bolsillo ahora mismo?",
          en: "That's why they invented coins and bills. Much easier to carry. Do you have any coins in your pocket right now?",
          sk: "Preto vynašli mince a bankovky. Oveľa ľahšie sa nosia. Máš teraz nejaké mince vo vrecku?",
        },
        animacion: null,
      },
      {
        texto: {
          es: "Pero el dinero de papel tiene un problema: los bancos pueden imprimir más y más. Cuando hay demasiado dinero, las cosas se vuelven más caras. A eso se le llama inflación.",
          en: "But paper money has a problem: banks can print more and more. When there's too much money, things become more expensive. That's called inflation.",
          sk: "Ale papierové peniaze majú problém: banky môžu tlačiť stále viac. Keď je príliš veľa peňazí, veci zdražejú. Tomu sa hovorí inflácia.",
        },
        animacion: null,
      },
      {
        texto: {
          es: "¡Y aquí es donde aparece algo mágico! Un invento que resuelve ese problema para siempre. ¡En la siguiente lección te lo cuento!",
          en: "And here is where something magical appears! An invention that solves that problem forever. I'll tell you in the next lesson!",
          sk: "A tu sa objavuje niečo magické! Vynález, ktorý tento problém navždy vyrieši. Poviem ti to v ďalšej lekcii!",
        },
        animacion: null,
      },
    ],
  },
  {
    id: "nace-bitcoin",
    nivel: 2,
    personaje: "satoshi",
    minijuego: "quiz-satoshi",
    titulo: {
      es: "Nace Bitcoin",
      en: "Bitcoin is Born",
      sk: "Zrodí sa Bitcoin",
    },
    slides: [
      {
        texto: {
          es: "¡Estupendo! Ya sabes qué es el dinero. Ahora te voy a contar la historia más emocionante del mundo: el nacimiento de Bitcoin.",
          en: "Excellent! You already know what money is. Now I'll tell you the most exciting story in the world: the birth of Bitcoin.",
          sk: "Výborne! Už vieš, čo sú peniaze. Teraz ti poviem najúžasnejší príbeh: zrod Bitcoinu.",
        },
        animacion: null,
      },
      {
        texto: {
          es: "En el año 2009, alguien llamado Satoshi Nakamoto — ¡como yo! — inventó un dinero digital especial. Un dinero que ningún banco puede controlar.",
          en: "In 2009, someone named Satoshi Nakamoto — like me! — invented a special digital money. A money that no bank can control.",
          sk: "V roku 2009 niekto menom Satoshi Nakamoto — ako ja! — vynašiel špeciálne digitálne peniaze. Peniaze, ktoré žiadna banka nemôže kontrolovať.",
        },
        animacion: "bitcoin-nace",
      },
      {
        texto: {
          es: "Bitcoin existe solo en internet, como un videojuego. Pero es real y vale dinero. ¡Mucho dinero!",
          en: "Bitcoin exists only on the internet, like a video game. But it's real and worth money. A lot of money!",
          sk: "Bitcoin existuje len na internete, ako videohra. Ale je skutočný a má hodnotu. Veľkú hodnotu!",
        },
        animacion: null,
      },
      {
        texto: {
          es: "Y lo mejor: solo habrá 21 millones de bitcoins en el mundo. ¡Nunca más! Imagina una caja con solo 21 caramelos en todo el mundo. ¿Crees que serían muy valiosos?",
          en: "And the best part: there will only ever be 21 million bitcoins in the world. Never more! Imagine a box with only 21 candies in the entire world. Would they be very valuable?",
          sk: "A to najlepšie: na svete bude len 21 miliónov bitcoinov. Nikdy viac! Predstav si škatuľku s iba 21 cukríkmi na celom svete. Boli by veľmi cenné?",
        },
        animacion: "21m",
      },
    ],
  },
  {
    id: "tu-primera-wallet",
    nivel: 3,
    personaje: "hodl",
    minijuego: "construye-bloque",
    titulo: {
      es: "Tu primera wallet",
      en: "Your first wallet",
      sk: "Tvoja prvá peňaženka",
    },
    slides: [
      {
        texto: {
          es: "¡Hola! Soy Hodl Hero. Te voy a enseñar cómo guardar tus bitcoins de forma segura. ¿Sabes lo que es una wallet?",
          en: "Hello! I'm Hodl Hero. I'll teach you how to safely store your bitcoins. Do you know what a wallet is?",
          sk: "Ahoj! Som Hodl Hero. Naučím ťa, ako bezpečne uchovávať svoje bitcoiny. Vieš, čo je peňaženka?",
        },
        animacion: null,
      },
      {
        texto: {
          es: "Una wallet de Bitcoin es como una mochila mágica en internet donde guardas tus bitcoins. Solo tú conoces la contraseña secreta para abrirla.",
          en: "A Bitcoin wallet is like a magic backpack on the internet where you keep your bitcoins. Only you know the secret password to open it.",
          sk: "Bitcoinová peňaženka je ako magický batoh na internete, kde uchovávaš svoje bitcoiny. Len ty poznáš tajné heslo.",
        },
        animacion: "wallet",
      },
      {
        texto: {
          es: "La regla número uno en Bitcoin es: NOT YOUR KEYS, NOT YOUR COINS. Significa: si no tienes la llave, no son tus bitcoins. ¡Nunca le des tu contraseña a nadie!",
          en: "The number one rule in Bitcoin is: NOT YOUR KEYS, NOT YOUR COINS. Which means: if you don't have the key, they're not your bitcoins. Never give your password to anyone!",
          sk: "Pravidlo číslo jeden v Bitcoine je: NOT YOUR KEYS, NOT YOUR COINS. Ak nemáš kľúč, nie sú to tvoje bitcoiny. Nikdy nikomu nedávaj heslo!",
        },
        animacion: null,
      },
    ],
  },
  {
    id: "los-mineros",
    nivel: 4,
    personaje: "miner",
    minijuego: "maquina-halving",
    titulo: {
      es: "Los Mineros y el Halving",
      en: "The Miners and the Halving",
      sk: "Mineri a Halving",
    },
    slides: [
      {
        texto: {
          es: "¡Hola! Soy Miner Mike. Yo y mis amigos mineros somos los que protegemos toda la red de Bitcoin con nuestros ordenadores.",
          en: "Hi! I'm Miner Mike. My miner friends and I protect the entire Bitcoin network with our computers.",
          sk: "Ahoj! Som Miner Mike. Ja a moji kamaráti mineri chránime celú sieť Bitcoinu pomocou počítačov.",
        },
        animacion: null,
      },
      {
        texto: {
          es: "Cuando alguien envía bitcoins, los mineros lo apuntan en un libro especial llamado blockchain. Y como premio, reciben bitcoins nuevos. ¡Es como un sueldo!",
          en: "When someone sends bitcoins, miners write it down in a special book called the blockchain. As a prize, they receive new bitcoins. It's like a salary!",
          sk: "Keď niekto pošle bitcoiny, mineri to zapíšu do špeciálnej knihy zvanej blockchain. Ako odmenu dostanú nové bitcoiny. Je to ako plat!",
        },
        animacion: null,
      },
      {
        texto: {
          es: "Pero cada 4 años pasa algo mágico: nuestro premio se reduce a la mitad. ¡A eso se le llama Halving! Por eso solo habrá 21 millones de bitcoins.",
          en: "But every 4 years something magical happens: our prize is cut in half. That's called the Halving! That's why there will only ever be 21 million bitcoins.",
          sk: "Ale každé 4 roky sa stane niečo magické: naša odmena sa zníži na polovicu. Tomu sa hovorí Halving! Preto bude len 21 miliónov bitcoinov.",
        },
        animacion: "halving",
      },
    ],
  },
  {
    id: "hodl-paciencia",
    nivel: 5,
    personaje: "oracle",
    minijuego: "hodl-challenge",
    titulo: {
      es: "El Poder del HODL",
      en: "The Power of HODL",
      sk: "Sila HODL",
    },
    slides: [
      {
        texto: {
          es: "Soy Oracle, la sabia del cripto. HODL es la palabra mágica de los bitcoiners. ¿Sabes qué significa?",
          en: "I'm Oracle, the crypto wise one. HODL is the magic word of bitcoiners. Do you know what it means?",
          sk: "Som Oracle, krypto mudrc. HODL je magické slovo bitcoinerov. Vieš, čo znamená?",
        },
        animacion: null,
      },
      {
        texto: {
          es: "HODL viene de 'hold' (aguantar) y significa: cuando el precio de Bitcoin baja, NO vendas. ¡Aguanta! Porque siempre vuelve a subir.",
          en: "HODL comes from 'hold' and means: when Bitcoin's price drops, do NOT sell. Hold on! Because it always goes back up.",
          sk: "HODL pochádza zo slova 'hold' a znamená: keď cena Bitcoinu klesne, NEPREDÁVAJ. Vydrž! Pretože vždy znova stúpne.",
        },
        animacion: "hodl-rocket",
      },
      {
        texto: {
          es: "La paciencia es el superpoder más grande en Bitcoin. Los que vendieron a 1.000$ se arrepintieron. Los que aguantaron hasta 60.000$ son felices.",
          en: "Patience is the greatest superpower in Bitcoin. Those who sold at $1,000 regretted it. Those who held until $60,000 are happy.",
          sk: "Trpezlivosť je najväčšia superschopnosť v Bitcoine. Tí, čo predali za 1 000 $, ľutovali. Tí, čo vydržali do 60 000 $, sú šťastní.",
        },
        animacion: null,
      },
      {
        texto: {
          es: "¿Listo para la prueba final del HODL? Vas a ver el precio de Bitcoin bajar y bajar… ¡Y tendrás que aguantar sin vender! ¿Crees que podrás?",
          en: "Ready for the final HODL test? You'll see Bitcoin's price go down and down… and you'll have to hold without selling! Do you think you can?",
          sk: "Pripravený na finálny HODL test? Uvidíš, ako cena Bitcoinu klesá a klesá… a budeš musieť vydržať bez predaja! Myslíš, že to dokážeš?",
        },
        animacion: null,
      },
    ],
  },
];

export const getLeccionKids = (id) =>
  LECCIONES_KIDS.find((l) => l.id === id) || null;
